import { render, staticRenderFns } from "./HoldInspection.vue?vue&type=template&id=3a65c713&"
import script from "./HoldInspection.vue?vue&type=script&lang=ts&"
export * from "./HoldInspection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports